import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Input, EventEmitter, Output, OnInit, Renderer, Component, ViewChild, ElementRef, forwardRef } from '@angular/core';

// Interfaces
import { Country } from '../interfaces/country.interface';

// Services
import { CountryService } from '../services/country.service';

@Component({
  selector: 'intl-phone',
  templateUrl: './intl-phone.component.html',
  styleUrls: ['./intl-phone.component.scss'],
  host: { '(document:click)': 'onClick($event)' },
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => IntlPhoneComponent),
    multi: true
  }]
})
export class IntlPhoneComponent implements OnInit, ControlValueAccessor {

  // Default Country
  @Input() phone: { cli_phone: string, country_code: string, dial_code: string };
  @Input() readOnly: boolean = false;
  @Input() defaultCountry = this.countryService.getCountry('us');

  @Output() blur = new EventEmitter<boolean>();

  // View Child
  @ViewChild('dialCode') dialCodeElement: ElementRef;

  error: boolean = false;
  // Countries
  countries;
  // Max input length
  inputMaxLength: number = 15;
  // Dial Code && Phone Number
  dialCode: string;
  phoneNumber: string;
  // Dropdown Open
  dropdownOpened: boolean = false;
  // Selected Country
  selectedCountry: any = this.defaultCountry;

  // Custom control form methods
  propagateChange = (_: any) => {};

  // Constructor
  constructor(
    private _eref: ElementRef,
    private renderer: Renderer,
    private countryService: CountryService
  ) { }

  // On component init
  ngOnInit() {
    this.error = false;
    this.countries = this.countryService.getCountry();
    this.changeCountry(this.selectedCountry, true);

    // Populate if we receive countryCode and phoneNumber
    if (this.phone) {
      this.selectedCountry = this.countryService.getCountry(this.phone.country_code);
      this.changeCountry(this.selectedCountry, true);
      this.phoneNumber = this.phone.cli_phone;
    }
  }

  // Changing the dial code
  private changeDialCode(dialCode): void {
    this.dialCodeElement.nativeElement.innerHTML = '+' + dialCode;

    // Set limit
    this.inputMaxLength = 15 - dialCode.toString().length;

    // Change the padding left
    this.renderer.setElementStyle(
      this.dialCodeElement.nativeElement.parentNode.querySelector('input'),
      'paddingLeft',
      70 + this.dialCodeElement.nativeElement.clientWidth + 'px'
    );
  }

  // Return the phone value
  public get value() {
    return this.phoneNumber;
  }

  // Set the phone value
  public set value(v: any) {
    this.phoneNumber = v;
    this.propagateChange({
      cli_phone: v,
      dial_code: this.selectedCountry.dial_code,
      country_code: this.selectedCountry.country_code
    });
  }

  // Write value
  public writeValue(value: any) {
    if (value) {
      // Write new value
      if (this._eref) {
        const input = this._eref.nativeElement.querySelector('input');
        input.value = value.cli_phone;
      }

      // Set phone number
      this.phoneNumber = value.cli_phone;
      this.selectedCountry = this.countryService.getCountry(value.country_code);
      this.changeDialCode(value.dial_code);
    }
  }

  // Register on change
  public registerOnChange(fn) {
    this.propagateChange = fn;
  }

  // Register on touched
  public registerOnTouched() {}

  // Open dropdown
  public toggleDropdown(): void {
    if (!this.readOnly) this.dropdownOpened = !this.dropdownOpened;
  }

  // Changing country
  public changeCountry(country, notToggle?: boolean): void {
    if (!notToggle) { this.toggleDropdown(); }
    this.changeDialCode(country.dial_code);
    this.selectedCountry = country;
    // Emit new value
    this.propagateChange({
      cli_phone: this.value,
      dial_code: this.selectedCountry.dial_code,
      country_code: this.selectedCountry.country_code
    });
  }

  // On element click
  public onClick(event) {
    if (!this._eref.nativeElement.contains(event.target) && this.dropdownOpened) {
      this.dropdownOpened = false;
    }
  }

  // On keypress
  public onKeyPress(event) {
    // Get code
    let code;
    if (event.keyCode) code = event.keyCode;
    else if (event.which) code = event.which; // Netscape 4.?
    else if (event.charCode) code = event.charCode; // Mozilla

    // Prevent non numerical chars
    const pattern = /^[0-9]+$/i;
    const inputChar = String.fromCharCode(code);

    if (!pattern.test(inputChar) && code !== 8 && code !== 46) event.preventDefault();
    else if (code === 8 || code === 46) return;

    // Limit the length
    if (this.value && this.value.length >= this.inputMaxLength) event.preventDefault();
  }

  // On input blur
  public onBlur() {
    this.error = (!!this.value && (this.value.length < 7)) || (!this.value);
    this.blur.emit(this.error);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/intl-phone/components/intl-phone.component.ts